import { getCurrentMsalInstance } from 'src/msal-dynamic-config';
import Storage from 'src/utils/storage/storage';

export default async function msalLogout() {
  Storage.removeTokens();

  const msalInstance = getCurrentMsalInstance();

  // Safety check: MSAL may not be initialized yet
  if (!msalInstance) {
    console.warn('MSAL instance not available. Redirecting to home.');
    window.location.href = '/';
    return;
  }

  const accounts = msalInstance.getAllAccounts();

  if (accounts.length === 0) {
    await msalInstance.logoutRedirect();
  } else {
    const currentAccount = msalInstance.getAccount({
      homeAccountId: accounts[0].homeAccountId
    });
    await msalInstance.logoutRedirect({
      account: currentAccount
    });
  }
}